import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { PageHeader } from '../components/PageHeader';
import {
  ArrowLeftRight,
  ChartBar,
  ChevronRight,
  CircleUser,
  PiggyBank,
  Settings,
  Store,
  Tags,
  Users,
  Wallet,
} from 'lucide-react';
import { IconSquare, ListGroup, listRowClass } from '../components/ui/card';
import { useCan, useMe } from '../lib/auth';

const LINKS = [
  { to: '/members', title: 'familyHub.members', hint: 'familyHub.membersHint', Icon: Users },
  { to: '/reports', title: 'familyHub.reports', hint: 'familyHub.reportsHint', Icon: ChartBar },
  { to: '/budgets', title: 'familyHub.budgets', hint: 'familyHub.budgetsHint', Icon: Wallet },
  { to: '/goals', title: 'familyHub.goals', hint: 'familyHub.goalsHint', Icon: PiggyBank },
  {
    to: '/categories',
    title: 'familyHub.categories',
    hint: 'familyHub.categoriesHint',
    Icon: Tags,
  },
  { to: '/family/payees', title: 'familyHub.payees', hint: 'familyHub.payeesHint', Icon: Store },
  {
    to: '/family/rates',
    title: 'familyHub.rates',
    hint: 'familyHub.ratesHint',
    Icon: ArrowLeftRight,
  },
  {
    to: '/family/settings',
    title: 'familyHub.settings',
    hint: 'familyHub.settingsHint',
    Icon: Settings,
  },
  { to: '/account', title: 'familyHub.account', hint: 'familyHub.accountHint', Icon: CircleUser },
] as const;

/** The Family tab: members, categories, exchange rates, family settings and the signed-in person's account. */
export function FamilyHubPage() {
  const { t } = useTranslation();
  const me = useMe();
  const canSeeBudgets = useCan('budgets.view');
  const links = LINKS.filter((link) => link.to !== '/budgets' || canSeeBudgets);
  return (
    <div className="flex flex-col gap-4">
      <PageHeader title={me.data?.family.name ?? t('familyHub.title')} />
      <ListGroup>
        {links.map(({ to, title, hint, Icon }) => (
          <li key={to}>
            <Link to={to} className={listRowClass}>
              <IconSquare>
                <Icon className="size-5" strokeWidth={2} />
              </IconSquare>
              <span className="flex min-w-0 flex-1 flex-col">
                <span className="text-[15px] font-medium">{t(title)}</span>
                <span className="text-xs text-muted">{t(hint)}</span>
              </span>
              <ChevronRight
                aria-hidden="true"
                className="size-5 shrink-0 text-muted rtl:rotate-180"
              />
            </Link>
          </li>
        ))}
      </ListGroup>
    </div>
  );
}
